import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountUpModule } from 'ngx-countup';

import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbDropdownModule, NgbAccordionModule, NgbNavModule, NgbProgressbarModule, NgbTooltipModule, NgbPopoverModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';

// Routings
import { PagesRoutingModule } from './pages-routing.modules';

// Modules
import { WidgetModule } from '../shared/widget/widget.module';

// Components
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';
import { GridModule } from '../_modules/modules/grid.module';
import { DynamicFormsModule } from '../_modules/modules/dynamic-forms.module';
import { FormsModule } from '@angular/forms';
import { CalanderSchedulerComponent } from "src/app/calander-scheduler/calander-scheduler.component";
import { CalendarModule, DateAdapter, MOMENT  } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { SchedulerModule } from "angular-calendar-scheduler";
import { AppService } from '../_services/common/app.service';
import * as moment from 'moment';
import { GradeModule } from '../_modules/modules/grade.module';


@NgModule({
  declarations: [
    CalanderSchedulerComponent,
  ],
  imports: [
    CommonModule,
    WidgetModule,
    PagesRoutingModule,
    ScrollToModule.forRoot(),
    NgApexchartsModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbProgressbarModule,
    NgbCollapseModule,
    NgbTooltipModule,
    NgbPopoverModule,
    CountUpModule,
    SharedModule,
    GoogleMapsModule,
    TranslateModule,
    GridModule,
    DynamicFormsModule,
    FormsModule,  
    GradeModule,  
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    SchedulerModule.forRoot({
      locale: "en",
      headerDateFormat: "daysRange",
      logEnabled: true,
    })
  ],
  
  providers: [
    AppService,
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: MOMENT, useValue: moment }

  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule { }
